import React from 'react';
import {Row, Col, Button, notification} from 'antd';

const ConfirmDelete = (callBack, message = undefined) => {
  const key = `open${Date.now()}`
  const ConfirmRemoveButtons = (
    <React.Fragment>
      <Row gutter={14}>
        <Col span={11}>
          <Button onClick={() => notification.close(key)}>
            Não
          </Button>
        </Col>
        <Col span={11}>
          <Button className="red-buttom" onClick={() => {
            callBack()
            notification.close(key)
          }}>
            Sim
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )

  notification.open({
    message: 'Atenção',
    description: message === undefined ? 'Você realmente deseja remover esse registro?' : message,
    btn: ConfirmRemoveButtons,
    key,
    duration: 0
  })
}

export default ConfirmDelete
